import { WORKFLOW_FIELDS } from '../fragments'

export default `
  ${WORKFLOW_FIELDS}
  mutation moveCard($projectId: String!, $input: MoveCardInput!) {
    moveCard(projectId: $projectId, input: $input) {
      ...WorkflowFields
    }
  }
`
